export const orderStatus = [
  'Todos',
  'Enviado',
  'Entregue',
  'Devolvido',
  'Cancelado',
  'Extraviado',
  'Processado'
]
